export default {
	"Coupon.CouponsAreAvailable": "可領取優惠券"
}